/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_HeadingInputs */

const tr_onbilgi_s2_heading = /** @type {(inputs: Onbilgi_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Hizmetin Temel Özellikleri`)
};

const en_onbilgi_s2_heading = /** @type {(inputs: Onbilgi_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Main Characteristics of the Service`)
};

const de_onbilgi_s2_heading = /** @type {(inputs: Onbilgi_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Wesentliche Merkmale der Dienstleistung`)
};

const ru_onbilgi_s2_heading = /** @type {(inputs: Onbilgi_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Основные характеристики услуги`)
};

/**
* | output |
* | --- |
* | "2. Main Characteristics of the Service" |
*
* @param {Onbilgi_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_heading = /** @type {((inputs?: Onbilgi_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_heading(inputs)
	if (locale === "de") return de_onbilgi_s2_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s2_heading(inputs)
	return tr_onbilgi_s2_heading(inputs)
});